import { ManualSection } from "./primitives"

const DOS = [
  "Benchmark every surface against the briefs pages and the auth screens. They define what finished looks like.",
  "Close quality gaps with composition care: section rhythm, semantic text tokens, one primary action per view. Never reach for new styles.",
  "Carry text hierarchy with Ink opacity steps on light surfaces; white opacity steps on navy.",
  "Use Highlighter Yellow like a highlighter: one action moment per view, always with Ink text.",
  "Make contributors visible: bylines, avatars, attribution, and why-it-matters notes are design elements, not metadata.",
  "Keep focus rings Byline Blue, and give every animation a prefers-reduced-motion alternative. The audience includes people in distress.",
]

const DONTS = [
  "Reach for batyr-mint in new work. It is retired, and stet green replaces it.",
  "Drift toward clinical health portals, Spotify-clone chrome, generic SaaS dashboards, or social-feed patterns.",
  "Do whiteboard-tool cosplay: sticky notes, floating cursors, hand-drawn arrows, draggable-everything.",
  "Gamify peer support: no streaks, XP, badges-as-rewards, leaderboards, or confetti.",
  "Add LMS energy: progress bars on everything, completion checkmarks, module numbering. A brief is a gift, not an assignment.",
  "Use Batyr Display or Aleo outside their lanes, reach for Batyr Display on a small task/tool title (use font-display — Aleo), add a second h1 for punch, or load fonts from a CDN.",
]

// The closing digest: DESIGN.md's named rules in two editorial columns.
export function RulesSection() {
  return (
    <ManualSection
      id="rules"
      title="House Rules"
      lede="The short version of DESIGN.md, for the next pair of hands at the desk."
    >
      <div className="grid max-w-5xl gap-10 lg:grid-cols-2">
        <div className="flex flex-col gap-4">
          <h3 className="text-batyr-stet-green text-lg font-semibold">
            Stet: let these stand
          </h3>
          <ul className="flex flex-col gap-3">
            {DOS.map((rule) => (
              <li key={rule} className="flex gap-3">
                <span
                  aria-hidden="true"
                  className="bg-surface-affirm mt-2 size-1.5 shrink-0 rounded-full"
                />
                <p className="text-secondary max-w-prose text-sm">{rule}</p>
              </li>
            ))}
          </ul>
        </div>
        <div className="flex flex-col gap-4">
          <h3 className="text-primary decoration-batyr-red-pencil text-lg font-semibold underline decoration-2 underline-offset-6">
            Struck by the red pencil
          </h3>
          <ul className="flex flex-col gap-3">
            {DONTS.map((rule) => (
              <li key={rule} className="flex gap-3">
                <span
                  aria-hidden="true"
                  className="bg-batyr-red-pencil mt-2 size-1.5 shrink-0 rounded-full"
                />
                <p className="text-secondary max-w-prose text-sm">{rule}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </ManualSection>
  )
}
